export const DECISION_MAKER_HASH_QUERY_PARAM_NAME = 'response';
export const SECTION_ID_MAPPING = {
	DECISION_MAKERS: 'decision-makers',
	UPDATES: 'updates',
	MEDIA_MENTIONS: 'media-mentions',
	SUPPORTER_VOICES: 'supporter-voices',
	SUPPORTER_VOICES_VIDEOS: 'supporter-voices-videos',
	ENDORSEMENTS: 'endorsements-section',
} as const;
